import { JetView } from 'webix-jet';
import { countries, devConfig, profile } from 'config/config';

/**
 * Class representing the FilterReferralsReportsView.
 * @extends JetView
 */
export default class FilterReferralsReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserId', // Input for User ID
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Referido'), // Localized label
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Referido'), // Placeholder text
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'DatepickerRegister', // Input for registration date
                            id: 'DatepickerRegister',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Registro'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text',
                            minWidth: 200,
                            name: 'DatepickerDeposit', // Input for deposit date
                            id: 'DatepickerDeposit',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Primer Deposito'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'State', // Dropdown for referral state
                            id: 'State',
                            label: _('Estado de Referido'), // Localized label
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 1, value: _('Activo') }, // Active option
                                { id: 0, value: _('Inactivo') }, // Inactive option
                            ],
                            value: 1, // Default value
                        },
                        {
                            view: 'radio',
                            name: 'Type', // Radio buttons for type selection
                            id: 'Type',
                            label: _('Tipo'), // Localized label
                            labelPosition: 'top',
                            minWidth: 200,
                            height:
                                screen.width < 500 || screen.height < 500
                                    ? 90 // Adjust height for small screens
                                    : 0,
                            value: 1, // Default value
                            options: [
                                { id: 1, value: _('Totales') }, // Total option
                                { id: 0, value: _('Detallado') }, // Detailed option
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    width: 140,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    type: 'form',
                    width: 140,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (filterdata.Type === '0' && filterdata.PlayerId === '') {
                            webix.message({
                                type: 'error',
                                text: _('El ID Referente es requerido'), // Error message
                            });
                            return;
                        } else if (filterdata.Type === '') {
                            webix.message({
                                type: 'error',
                                text: _('El Tipo es requerido'), // Error message
                            });
                            return;
                        }
                        this.app.callEvent('referralsReportPlayerMain:filter', [
                            filterdata, // Trigger event with filter data
                        ]);
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form',
            type: 'clean',
            autofit: true,
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion on larger screens
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and attaches events.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('DatepickerRegister').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal for registration date
        });
        $$('DatepickerDeposit').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal for deposit date
        });
    }
}

// FILE DOCUMENTED
